






















































































































import Element from 'element-ui'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { UploadOptData } from '@/api/common/upload'
import { AttachInfo } from '@/api/common/attach'
import { CruiseEventData, emptyCruiseEvent, getInfo, putData, postData } from '@/api/heritageCruise/cruiseEvent'
import { validateIntKey, validateArrayNotEmpty, showVaildMsg } from '@/configs/validate'
import { DDLItem, DefDDLItem, getHiddenDanger } from '@/api/common/select'
import { enFirstType } from '@/configs/enums'
import { getCascaderOpts, getCascaderValue } from '@/configs/functions'
//import ViewLink from '@/components/viewLink.vue'
import hspGallery from '@/components/upload/gallery.vue'
import singleFile from '@/components/upload/singleFile.vue'
//import hspUpload from '@/components/upload/index.vue'
import { videoFormat } from '@/configs/fileTypes'
import PageForm from '@/components/pageLayout/form.vue'

import { namespace } from 'vuex-class'
const DataSourceModule = namespace('dataSource')

const getFormRules = (id: number, form: { [key: string]: string | any }) => {
  return {
    IssueFrom: [{ required: true, validator: validateIntKey('请选择事件来源'), trigger: 'change' }],
    // IssueLevel: [{ required: true, validator: validateIntKey('请选择事件级别'), trigger: 'change' }],
    IssueType: [{ required: true, validator: validateIntKey('请选择隐患问题'), trigger: 'change' }],
    IssueSpecification: [{ required: true, message: '请填写事件描述', trigger: 'blur' }],
    IssueLevelSpec: [{ required: true, message: '请填写隐患问题描述', trigger: 'blur' }],
    ResponsiblityUnit: [{ required: true, message: '请填写责任单位', trigger: 'blur' }],
    ResponsiblityPerson: [{ required: true, message: '请填写责任人', trigger: 'blur' }],
  }
}
@Component({
  components: { PageForm, hspGallery, singleFile }
})
export default class CruiseEventForm extends Vue {
  public collapseNames = ['base']
  public videoExt: string = videoFormat
  public firstType: number = enFirstType.Select
  public defItem: DDLItem = DefDDLItem(this.firstType)
  public form: CruiseEventData = Object.assign({}, emptyCruiseEvent)
  public loading = false
  public rules = getFormRules(0, this.form)
  public issueFromList: DDLItem[] = []
  public cruiseItemList: any[] = []
  public hiddenDangerList: any[] = []
  public hiddenDangerValue: number[] = []
  // dynamic component
  public $refs!: {
    formCtrl: PageForm
  }
  public hasFile: boolean = false
  public hasVideo: boolean = false
  public onGalleryChange(data: { opts: UploadOptData, files: AttachInfo[] }) {
    const list = data.files
    this.hasFile = list.length > 0
    console.log(data)
  }
  public onFileChange(data: { opts: UploadOptData, file: AttachInfo }) {
    this.hasVideo = data.file.Id > 0
  }
  public issueTypeChange(value: any) {
    this.form.IssueType = value && value.length > 0 ? value[value.length - 1] : 0
  }
  public created() {
    this.fetchSource()
  }
  public mounted() {
    this.fetchData()
  }
  @DataSourceModule.Getter('dataSource')
  public dataSource!: any
  public fetchSource() {
    const data = Object.assign({}, this.dataSource)
    if (data) {
      this.cruiseItemList = data.cruiseItemList
      this.issueFromList = data.issueFromList
      // this.hiddenDangerList = data.hiddenDangerList
      this.hiddenDangerList = getCascaderOpts(data.hiddenDangerList)
    }
  }
  public fetchEvent(id: number) {
    this.loading = true
    getInfo(id).then((response: { data: any }) => {
      if (response.data) {
        this.form = response.data
        this.rules = getFormRules(this.form.Id, this.form)
        this.$nextTick(() => {
          if (this.form.IssueType > 0 && this.hiddenDangerList.length > 0) {
            this.hiddenDangerValue = getCascaderValue(this.hiddenDangerList, this.form.IssueType)
          }
        })
        this.loading = false
      }
    })
  }
  public fetchData() {
    const id = +this.$router.currentRoute.params.id || 0
    this.fetchEvent(id)
  }
  public chkAttachs() {
    if (!this.hasFile) {
      this.$message({
        message: '请上传照片',
        type: 'warning'
      })
      return false
    }
    return true
  }
  public onSubmit() {
    // if (this.chkAttachs()) {
    //   alert('ok')
    // }
    // else {
    //   alert('noooooo')
    // }
    // return false

    let values = this.hiddenDangerValue
    this.form.IssueType = values && values.length > 0 ? values[values.length - 1] : 0
    if (this.chkAttachs()) {
      const promist = this.form.Id > 0 ?
        putData(this.form.Id, this.form) : postData(this.form)
      promist.then((response: { data: any }) => {
        const data = response.data
        if (data && !data.IsError) {
          this.$message({
            message: '提交成功',
            type: 'success'
          })
          this.$router.push({ path: `/CruiseEvent` }).catch((data: any) => {
            console.log(this.$route.path, data)
          })
        } else {
          this.$message({
            dangerouslyUseHTMLString: true, message: `${data.Message}`, type: 'warning'
          })
          console.log(response)
        }
      })
    }
  }
  public onCancel() {
    this.$router.push({ path: `/CruiseEvent` }).catch((data: any) => {
      console.log(this.$route.path, data)
    })
  }
  @Watch('$route')
  public onRouteChange(route: any) {
    this.fetchData()
  }
}
